export var Shadows;
(function (Shadows) {
    Shadows["Default"] = "0 8px 32px rgba(16, 33, 60, 0.24), 0 0 8px rgba(0, 0, 0, 0.03)";
    Shadows["Primary"] = "0 8px 10px rgba(219, 60, 0, 0.2), 0 6px 20px rgba(219, 60, 0, 0.12), 0 8px 14px rgba(219, 60, 0, 0.14)";
})(Shadows || (Shadows = {}));
//# sourceMappingURL=shadows.js.map